<!--
 * @description: 搜索表格
 * @author: ckj
 * @date: 2024/09/20 10:16
-->
<template>
  <ls-search-form ref="searchForm" :formList="formList" @search="onSearch" @reset="onReset">
    <global-select
      slot="djlxTypes"
      :dropdown-match-select-width="false"
      selectType="selectMultiple"
      v-decorator="['djlxTypes']"
      requestApi="/inv/invOnhandQuantities/findAsnAndDeliveryOrderTypeList"
      :selectItem="{ value: 'label', label: 'realValue' }"
      sourseField="res"
    />
    <global-select
      v-decorator="['zzbm']"
      :allow-clear="false"
      :default-active-first-option="defaultSelect"
      slot="orgCode"
      :value.sync="queryParams.zzbm"
      selectType="select"
      :selectData="inventOrg"
      :selectItem="{ value: 'realValue', label: 'label' }"
    />
    <!-- <ls-select-page
        slot="projectGroupNo"
        search-key="attributeName"
        value-key="attributeCode"
        v-decorator="['projectTeamList',{initialValue:[]}]"
        placeholder="请选择"
        mode="multiple"
        :datas="projectGroupList">
      <template slot="select-option" slot-scope="{ items }">
        <a-select-option
            v-for="item in items"
            :key="item.attributeCode"
        >{{ item.attributeName }}</a-select-option>
      </template>
    </ls-select-page> -->
  </ls-search-form>
</template>

<script>
import { mapState } from 'vuex'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  name: "SearchInput",
  data() {
    return {
      // 查询参数
      queryParams: {
        zzbm: undefined,
        wbdh: undefined,
        shd: undefined,
        ckdh: undefined,
        psDate: undefined,
        jhDate: undefined,
        shDate: undefined,
        scpc: undefined,
        jhlsh: undefined,
        itemCode: undefined,
        djlxTypes: undefined,
        tenantId: undefined,
        gdh: undefined
      },
      formList: [
        {
          label: '工单号',
          decorator: ['gdh'],
          type: 'input'
        },
        {
          label: '组织编码',
          decorator: ['zzbm'],
          type: 'orgCode'
        },
        {
          label: '子库代码',
          decorator: ['tenantId'],
          type: 'input'
        },
        {
          label: '单据类型',
          decorator: ['djlxTypes'],
          type: 'djlxTypes'
        },
        {
          label: '物料编码',
          decorator: ['wlbm'],
          type: 'input'
        },
        {
          label: '标签ID',
          decorator: ['jhlsh'],
          type: 'input'
        },
        {
          label: '生产批次号',
          decorator: ['scpc'],
          type: 'input'
        },
        {
          label: '收货日期',
          type: 'range',
          decorator: ['shDate'],
          disposeFormat: {
            shDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            shDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '交货日期',
          type: 'range',
          decorator: ['jhDate'],
          disposeFormat: {
             jhDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
             jhDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '配送日期',
          type: 'range',
          decorator: ['psDate'],
          disposeFormat: {
            psDateFrom: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            psDateTo: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        },
        {
          label: '出库单号',
          type: 'input',
          decorator: ['ckdh']
        },
        {
          label: '收货单号',
          type: 'input',
          decorator: ['shd']
        },
        {
          label: '外部单号',
          type: 'input',
          decorator: ['wbdh']
        }
      ]
    }
  },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created() {
    // 处理缓存逻辑
    this.getHistoryCache(
      'searchForm',
      'zzbm',
      {
        shDate: ['shDateFrom', 'shDateTo'],
        jhDate: ['jhDateFrom', 'jhDateTo'],
        psDate: ['psDateFrom', 'psDateTo']
      }
    )
  },
  mounted() {
    if (!(this.cashHistory && this.cashHistory[this.$route?.fullPath])) {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      end = this.$moment(end)
      start = this.$moment(start)
      this.$refs.searchForm.form.setFieldsValue({ shDate: [start, end] })
    }
   },
  methods: {
    onSearch(val) {
      this.$emit('search', val)
    },
    onReset() {
      this.$refs.searchForm.form.setFieldsValue({
        zzbm: undefined,
        wbdh: undefined,
        shd: undefined,
        ckdh: undefined,
        psDate: undefined,
        jhDate: undefined,
        shDate: undefined,
        scpc: undefined,
        jhlsh: undefined,
        wlbm: undefined,
        djlxTypes: undefined,
        tenantId: undefined,
        gdh: undefined
      })
      this.$emit('reset', {})
    }
  }
}
</script>

<style scoped>

</style>
